import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const ModalWindowFooter = props => {
  const { className, children, ...other } = props;

  return (
    <div className={clsx("em-c-modal__footer", className)} {...other}>
      {children}
    </div>
  );
};

ModalWindowFooter.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

ModalWindowFooter.defaultProps = {
  className: "",
  children: null
};

export default ModalWindowFooter;
